import HashtagIcon from "assets/icons/Hashtag";
import useCurrency from "helpers/useCurrency";

export default function productsSelectBoxLayout(props: any) {
  const { image, icon, label, dsc, ind, title, footer, code } = props;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { defCur } = useCurrency();
  return (
    <div className="flex gap-4 w-full">
      <div className="flex flex-col items-center justify-between gap-2">
        <div className="flex w-full justify-center items-center">
          <div
            className={`rounded-full overflow-hidden border border-slate-400 bg-center bg-cover bg-no-repeat`}
            onClick={() => image.substring(0, 1) !== '/' && window.open(image, "_blank")}
            style={{
              backgroundImage: `url("${image}")`,
              minHeight: 52,
              minWidth: 52,
            }}
          />
        </div>
        {code && <div>
          <span className="text-xs">کد کالا: </span>
          <span
            className={`text-xs`}
          >
            {code}
          </span>
        </div>}
      </div>
      <div className="flex flex-col gap-1 justify-center w-full overflow-hidden">
        <span style={{ fontSize: 13 }} className="text-dark-6 whitespace-normal">
          {title}
        </span>
        <div className="flex justify-between items-center gap-2">
          <div className="flex gap-1 items-center">
            <span
              className="bg-slate-100 rounded w-4 h-4 flex justify-center items-center"
              style={{ fontSize: 14 }}
            >
              <HashtagIcon color="#7E8C9E" style={{ transform: "scale(0.8)" }} />
            </span>
            <span style={{ fontSize: 16 }} className="text-dark-6">
              {ind}
            </span>
          </div>
          <span className="text-sm text-slate-400">{dsc}</span>
        </div>
        <div className="flex gap-2 justify-end">
          <div>
            <span className="text-xs">قیمت فروش</span>
            <div className="flex gap-1 items-center justify-between">
              <span className="text-gray-400 text-xs">{defCur.en_title}</span>
              <span className="text-sm">
                {Intl.NumberFormat().format(props.sellPrice || 0)}
              </span>
            </div>
          </div>
          <span>/</span>
          <div>
            <span className="text-xs">قیمت خرید</span>
            <div className="flex gap-1 items-center justify-between">
              <span className="text-gray-400 text-xs">{defCur.en_title}</span>
              <span className="text-sm">
                {Intl.NumberFormat().format(props.buyPrice || 0)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
